import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Ruta HISTÓRICA · la bandeja salió de Administración al módulo Solicitudes de catálogo
 * (`/solicitudes-catalogo`, visible por los responsables de cada tipo). Se conserva para
 * que los enlaces viejos (correos, marcadores) sigan llegando.
 */
export const Route = createFileRoute("/_authed-tw/admin/solicitudes-catalogo")({
  beforeLoad: () => {
    throw redirect({ to: "/solicitudes-catalogo", replace: true });
  },
});
